import React from 'react'
import { Card, CardContent, Container, Typography } from '@material-ui/core'

import Page from '../Page'
// import { useRouteMatch } from 'react-router'
import { FORM_ACTIONS } from 'src/utils/constants/general'
import ErrorsValidation from '../shared/displayErrorsValidations'
import FormRol from './shared/form'
import PageContainer from 'src/containers/shared/PageContainer';

const EditRol = (props) => {
  const {
    rol,
    permissions,
    errors,
    loading,
    updateRol,
  } = props;

  // const match = useRouteMatch()
  return (
    <PageContainer title="Editar Rol" maxWidth={false}>
        <Typography
          color="textPrimary"
          variant="h2"
          className="mb-3"
        >
          Editando Rol "{`${rol.display_name}`}"
        </Typography>
        <ErrorsValidation errors={errors} />
        <Card>
          <CardContent>
            <FormRol 
              action={FORM_ACTIONS.EDIT} 
              rol={rol} 
              permissions={permissions} 
              updateRol={updateRol} 
              loading={loading}
            />
          </CardContent>
        </Card>
    </PageContainer>
  )
}

export default EditRol
